<template>
  <div class='box'>
      <!-- <iframe src="https://class.mifengdao.com/calc" frameborder="0"></iframe> -->
      <!-- <iframe src="http://class.t.mifengdao.com/calc" frameborder="0"></iframe> -->
      <iframe :src="appConfigData.classUrl+'/calc'" frameborder="0"></iframe>
  </div>
</template>

<script>
import appConfig from '@/api/appConfig'
export default {
  name: '',
  data() {
    return {
        appConfigData:appConfig
    };
  },
  computed:{
  },
  watch:{
  },
  methods: {},
};
</script>

<style lang='scss' scoped>

</style>
